import React from 'react';

/**
 * The mark beside a required field's label: one gray asterisk, the same on
 * every form in the app.
 *
 * Use this rather than writing the span by hand. Hand-written ones had drifted
 * into four reds and two grays with three different spacings; with one
 * component the colour cannot split again.
 */
const RequiredMark: React.FC<{ className?: string }> = ({ className = '' }) => (
  <span className={`ml-0.5 text-neutral-medium ${className}`}>*</span>
);

export default RequiredMark;
